export enum TherapyState {
  NotSet = 'not_set',
  Started = 'started_continued',
  WaitingForFeedback = 'waiting_for_feedback',
  Denied = 'denied',
  Paused = 'paused',
  ConsultationRequested = 'consultation_requested',
  Finished = 'finished',
}
